<template>
  <b-row>
    <b-col md="6" class="d-flex justify-content-between">
      <div class="d-flex">
        <b-form-input
          size="lg"
          placeholder="search job name..."
          v-model="filters.search"
        ></b-form-input>
        <b-button variant="primary" class="ml-2" @click="$emit('refetch')">
          <i class="fa fa-search"></i>
        </b-button>
        <b-button
          variant="outline-primary"
          class="d-flex align-items-center mx-2"
          @click="$emit('toggleFilter')"
        >
          <i class="fas fa-sliders"></i>
          <p class="text-truncate m-0"> Filter Data </p>
        </b-button>
        <b-button
          variant="primary"
          class="d-flex align-items-center"
          @click="$emit('resetFilter')"
        >
          <p class="text-truncate m-0">Reset Filter</p>
        </b-button>
      </div>
    </b-col>

    <!-- <b-col md="6">
      <div class="text-right">
        <strong>Display : &nbsp;</strong>
        <div class="btn-group">
          <button
            type="button"
            @click="view_style = 'list'"
            class="btn btn-outline-primary"
            :class="{ 'btn-menu-active': view_style === 'list' }"
            ><span class="fa fa-list"></span
          ></button>
          <button
            type="button"
            @click="view_style = 'calendar'"
            class="btn btn-outline-primary"
            :class="{ 'btn-menu-active': view_style === 'calendar' }"
            ><span class="fa fa-calendar"></span
          ></button>
          <button
            type="button"
            @click="view_style = 'gantt-chart'"
            class="btn btn-outline-primary"
            :class="{ 'btn-menu-active': view_style === 'gantt-chart' }"
            ><span class="fa fa-bars"></span
          ></button>
        </div>
      </div>
    </b-col> -->

    <!-- Filter Preview -->
    <FilterMaintenancePreview :filters="filters" />
    <!-- End Filter Preview -->

    <b-col>
      <template v-if="!maintenance.isLoading">
        <template v-if="view_style === 'list'">
          <ProgressList
            :maintenance="maintenance"
            @refetch="$emit('refetch')"
            @viewDetailMaintenance="(e) => viewDetailMaintenance(e.id, e.type)"
            @onApprove="(id) => viewDetailMaintenance(id, 'ON_APPROVE')"
            @onReview="(id) => viewDetailMaintenance(id, 'ON_REVIEW')"
            @onPostpone="
              (row) => {
                modalPostpon.data = row
                modalPostpon.show = true
              }
            "
            :canAdd="canAdd"
            :canApprove="canApprove"
            :canReview="canReview"
            :loadPage="viewMenu"
          />
        </template>
      </template>
      <template v-else>
        <div class="py-5 w-100 d-flex justify-content-center">
          <b-spinner label="Spinning"></b-spinner>
        </div>
      </template>
    </b-col>

    <!-- Sidebar View -->
    <b-sidebar
      v-model="viewDetailMaintenanceSidebar"
      id="view-detail-maintenance"
      title="View Job Maintenance"
      :width="actionMaintenanceSidebar == 'VIEW_DETAIL' ? '50%' : '100%'"
      backdrop-variant="dark"
      right
      backdrop
      shadow
      header-class="bg-white"
    >
      <template>
        <ViewMaintenanceDetail
          v-if="viewDetailMaintenanceSidebar"
          :isEdit="isEdit"
          @save="closeDetailMaintenance()"
          @close="closeDetailMaintenance()"
          :maintenance-id="selectedMaintenanceId"
          :action="actionMaintenanceSidebar"
          @onApprove="onApprove"
          @onReview="onReview"
        />
      </template>
    </b-sidebar>
    <!-- End Sidebar View -->

    <!-- Modal Postpone -->
    <b-modal
      v-model="modalPostpon.show"
      size="lg"
      title="Postpone Maintenance"
      hide-footer
      centered
    >
      <PostponeForm
        :maintenanceDetailData="modalPostpon.data"
        @refetch="$emit('refetch')"
        @close="
          () => {
            modalPostpon.show = false
          }
        "
      />
    </b-modal>
    <!-- End Modal Postpone -->
  </b-row>
</template>

<script>
import { maintenanceActions } from '@/src/Utils/helper'
import ProgressCalendar from './Components/ProgressCalendar.vue'
import ProgressGanttChart from './Components/ProgressGanttChart.vue'
import ProgressList from './Components/ProgressList.vue'
import ViewMaintenanceDetail from './ViewMaintenanceDetail.vue'
import MaintenanceSummaryListFinish from './MaintenanceSummaryListFinish.vue'
import PostponeForm from './Components/PostponeForm.vue'
import FilterMaintenancePreview from './Components/FilterMaintenancePreview.vue'

export default {
  name: 'MaintenanceSummaryListProgress',
  components: {
    ProgressCalendar,
    ProgressGanttChart,
    ProgressList,
    ViewMaintenanceDetail,
    MaintenanceSummaryListFinish,
    PostponeForm,
    FilterMaintenancePreview,
  },
  props: {
    viewMenu: {
      type: String,
      default: 'progress',
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
    maintenance: {
      type: Object,
      default: () => {
        return {
          data: null,
          meta: null,
          isLoading: false,
        }
      },
    },
    jobClassList: {
      type: Array,
      default: () => [],
    },
    jobTypeList: {
      type: Array,
      default: () => [],
    },
    statusList: {
      type: Array,
      default: () => [],
    },
    fleetCategoryOpt: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      view_style: 'list',
      selectedMaintenanceId: null,
      viewDetailMaintenanceSidebar: false,
      isEdit: false,
      actionMaintenanceSidebar: 'VIEW_DETAIL',
      lsProfile: JSON.parse(localStorage.getItem('profile')),
      modalPostpon: {
        data: null,
        show: false,
      },
    }
  },
  methods: {
    ...maintenanceActions,
    onApprove(id) {
      this.$swal({
        title: 'Lakukan Approve Maintenance ?',
        text: `Periksa Kembali Seluruh Data`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Approve',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let payload = {
            id,
          }
          const res = await this.saveApproveMaintenance(payload)

          if (res.status === 'success') {
            this.$swal(`Approve Berhasil`, '', 'success')
            this.closeDetailMaintenance()
          } else {
            this.$swal(`Oops!`, res.data.message, 'error')
          }
        }
      })
    },
    onReview(id) {
      this.$swal({
        title: 'Lakukan Review Maintenance ?',
        text: `Periksa Kembali Seluruh Data`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Review',
      }).then(async (result) => {
        if (result.isConfirmed) {
          let payload = {
            id,
          }
          const res = await this.saveReviewMaintenance(payload)
          if (res.status === 'success') {
            this.$swal(`Review Berhasil`, '', 'success')
            this.closeDetailMaintenance()
          } else {
            this.$swal(`Oops!`, res.data.message, 'error')
          }
        }
      })
    },
    viewDetailMaintenance(id, action = 'VIEW_DETAIL', isEdit = false) {
      if (typeof id !== 'undefined' && id) {
        this.selectedMaintenanceId = id
        this.viewDetailMaintenanceSidebar = true
        this.actionMaintenanceSidebar = action
        this.isEdit = isEdit
      }
    },
    async closeDetailMaintenance() {
      this.selectedMaintenanceId = null
      this.viewDetailMaintenanceSidebar = false
      this.$emit('refetch')
    },
  },
  computed: {
    maintenancePermission() {
      return this.lsProfile.menu
        .find((menu) => menu.menu === 'Apps')
        ?.child.find((child) => child.menu === 'Technical')
        ?.child.find((child) => child.menu === 'Maintenance')
    },
    canAdd() {
      return this.maintenancePermission
        ? this.maintenancePermission?.add
        : false
    },
    canReview() {
      return this.maintenancePermission
        ? this.maintenancePermission?.review
        : false
    },
    canApprove() {
      return this.maintenancePermission
        ? this.maintenancePermission?.approval
        : false
    },
  },
  mounted() {},
}
</script>

<style scoped>
.btn-menu:hover {
  background: #0088af !important;
  border: #0088af;
}

.btn-menu-active {
  background: #0088af !important;
  color: white !important;
}
</style>
